module.exports = __webpack_public_path__ + "img/features-content-img-2-en.ce7e973d.png";